import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'

import { getAnnexationsForDayOptions } from '@/api/main/@tanstack/react-query.gen'
import { getTimezone } from '@/utils/datetime'
import { DISPLAY_ANNEXATIONS as isAnnexationsEnabled } from '@/constants'

const ANNEXATIONS_TIMEOUT_MS = 10_000

/**
 * Fetches today's annexations (in the configured timezone). The query is disabled
 * if VITE_DISPLAY_ANNEXATIONS is not 'true' so we don't make pointless calls.
 */
export const useAnnexationsForToday = () => {
  const today = dayjs().tz(getTimezone()).format('YYYY-MM-DD')

  const query = useQuery({
    ...getAnnexationsForDayOptions({
      path: { annexation_date: today },
      signal: AbortSignal.timeout(ANNEXATIONS_TIMEOUT_MS),
    }),
    enabled: isAnnexationsEnabled,
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  return { ...query, displayEnabled: isAnnexationsEnabled }
}

export { isAnnexationsEnabled }
